module.exports = __webpack_public_path__ + "static/media/projectx-logo.52738155.png";